import styled from 'styled-components';
import media from 'themes/media';

const Header = styled.div`
  position: relative;
  z-index: 999;
  min-height: 60px;
  background: #003765;
  border-radius: 0 0 10px 10px;
  ${media.greaterThan('desktop')`
    display: none;
  `};
`;

const PageName = styled.h3`
  font-family: 'Untitled Sans', serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.04em;
  color: white;
`;

const HeaderInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;

  ${media.greaterThan('desktop')`
    padding: 30px 20px 0;
  `};
`;

const MobControls = styled.div`
  display: flex;
  align-items: center;
  ${media.greaterThan('desktop')`
    display: none;
  `}
`;

export { Header, MobControls, HeaderInner, PageName };
